var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro"},[_c('div',{staticClass:"intro-text"},[_vm._v(_vm._s(_vm.text))]),_c('com-button',{attrs:{"dark":true},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Proceed")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }